// Imports ------------------------------------------------------------------->

import {Service, service} from "./di";
import * as array from "../utils/array";

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

// Having this service is stupid - we should be able to piggy back off the clipped coupon provider to return
// L2C as well as print coupons.
// See: FW-1326 Consolidate print coupon clipping services

export enum BasketItemStatus {
	CLIPPED = "clipped",
	PRINTED = "printed"
}

@service
export class PGPrintCouponService extends Service {

	private _printCoupons: any[] = [];

	public addCoupon(coupon: any) {
		this._printCoupons.push(coupon);
	}

	public removeCoupon(id: string) {
		let idx = -1;
		this._printCoupons.forEach((coupon, i) => {
			if (coupon.couponId === id) {
				idx = i;
			}
		});
		if (idx >= 0) {
			this._printCoupons.splice(idx, 1);
		}
		return;
	}

	public isPrinted(id: string) {
		const coupon = array.find(this._printCoupons, (coupon) => coupon.couponId === id);
		return coupon && coupon.status === BasketItemStatus.PRINTED;
	}

	public isClipped(id: string) {
		const coupon = array.find(this._printCoupons, (coupon) => coupon.couponId === id);
		return coupon && coupon.status === BasketItemStatus.CLIPPED;
	}

	public clear() {
		this._printCoupons = [];
	}

	public getCoupons() {
		return this._printCoupons;
	}
}
